(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  const shippingMessage = document.querySelector('[data-squizy-free-shipping]');
  if (shippingMessage && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    const threshold = Number(shippingMessage.dataset.threshold);
    const pending = shippingMessage.querySelector('[data-squizy-shipping-pending]');
    const ready = shippingMessage.querySelector('[data-squizy-shipping-ready]');
    const remaining = shippingMessage.querySelector('[data-squizy-shipping-remaining]');
    const formatMoney = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    });
    const updateShippingMessage = (totalPrice) => {
      const amountLeft = Math.max(0, threshold - totalPrice);
      pending.hidden = amountLeft === 0;
      ready.hidden = amountLeft > 0;
      remaining.textContent = formatMoney.format(amountLeft / 100);
    };

    subscribe(PUB_SUB_EVENTS.cartUpdate, async ({ cartData }) => {
      if (typeof cartData?.total_price === 'number') {
        updateShippingMessage(cartData.total_price);
        return;
      }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        if (response.ok) updateShippingMessage((await response.json()).total_price);
      } catch {
        return;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.querySelectorAll('[data-squizy-clear-cart]').forEach((button) => {
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Unable to clear cart');
        window.location.reload();
      } catch {
        button.disabled = false;
        button.textContent = button.dataset.errorLabel;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  document.querySelectorAll('[data-squizy-tracking]').forEach((tracking) => {
    const form = tracking.querySelector('[data-squizy-tracking-form]');
    const input = tracking.querySelector('[data-squizy-tracking-number]');
    const submit = tracking.querySelector('[data-squizy-tracking-submit]');
    const status = tracking.querySelector('[data-squizy-tracking-status]');
    const result = tracking.querySelector('[data-squizy-tracking-result]');
    const fallback = tracking.querySelector('[data-squizy-tracking-fallback]');
    let scriptPromise;

    const loadWidget = () => {
      if (window.YQV5?.trackSingle) return Promise.resolve();
      if (scriptPromise) return scriptPromise;

      scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://www.17track.net/externalcall.js';
        script.async = true;
        script.onload = () => {
          if (window.YQV5?.trackSingle) resolve();
          else reject(new Error('17TRACK unavailable'));
        };
        script.onerror = () => reject(new Error('17TRACK unavailable'));
        document.head.append(script);
      }).catch((error) => {
        scriptPromise = null;
        throw error;
      });

      return scriptPromise;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const number = input.value.trim();
      if (!number) return;

      submit.disabled = true;
      status.textContent = 'On cherche ton colis…';
      result.hidden = false;
      fallback.hidden = true;
      result.replaceChildren();

      try {
        await loadWidget();
        window.YQV5.trackSingle({
          YQ_ContainerId: result.id,
          YQ_Height: 560,
          YQ_Fc: '0',
          YQ_Lang: 'fr',
          YQ_Num: number,
        });
        status.textContent = '';
        fallback.hidden = false;
      } catch {
        result.hidden = true;
        fallback.hidden = false;
        status.textContent = 'Le suivi est momentanément indisponible. Réessaie dans quelques instants.';
      } finally {
        submit.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-squizy-faq]').forEach((faq) => {
    faq.querySelectorAll('strong').forEach((emphasis) => {
      if (emphasis.textContent.trim() !== 'Suivre la livraison' || emphasis.closest('a')) return;

      const link = document.createElement('a');
      link.href = faq.dataset.squizyFaqDeliveryUrl;
      emphasis.replaceWith(link);
      link.append(emphasis);
    });

    faq.querySelectorAll('strong').forEach((emphasis) => {
      const facebookText = Array.from(emphasis.childNodes).find((node) =>
        node.nodeType === Node.TEXT_NODE && node.textContent.includes('Facebook')
      );
      if (!facebookText) return;

      const [before, after] = facebookText.textContent.split('Facebook');
      const link = document.createElement('a');
      link.href = 'https://www.facebook.com/profile.php?id=61594121578011';
      link.textContent = 'Facebook';
      facebookText.replaceWith(document.createTextNode(before), link, document.createTextNode(after));
    });

    let currentAnswer = null;

    Array.from(faq.children).forEach((node) => {
      if (node.matches('h2, h3')) {
        currentAnswer = null;
        return;
      }

      if (node.matches('ul') && node.children.length === 1) {
        const question = node.firstElementChild;
        const label = question?.textContent.trim() || '';

        if (question?.matches('li') && !question.querySelector('ul, ol') && label.endsWith('?')) {
          const item = document.createElement('details');
          const summary = document.createElement('summary');
          const title = document.createElement('span');
          const chevron = document.createElement('span');
          const answer = document.createElement('div');

          item.className = 'squizy-faq__item';
          title.textContent = label;
          chevron.className = 'squizy-faq__chevron';
          chevron.setAttribute('aria-hidden', 'true');
          answer.className = 'squizy-faq__answer';
          summary.append(title, chevron);
          item.append(summary, answer);
          node.replaceWith(item);
          currentAnswer = answer;
          return;
        }
      }

      if (currentAnswer) currentAnswer.append(node);
    });
  });

  document.querySelectorAll('[data-squizy-security-layout]').forEach((layout) => {
    const copy = layout.querySelector('[data-squizy-security-copy]');
    const certificates = layout.querySelector('[data-squizy-security-certificates]');

    if (!copy || !certificates) return;

    copy.querySelectorAll('p').forEach((paragraph) => {
      if (paragraph.querySelector('img')) certificates.append(paragraph);
    });
  });

  document.querySelectorAll('[data-squizy-favorites-page]').forEach((page) => {
    const storageKey = 'squizy-favorites-v1';
    const grid = page.querySelector('[data-squizy-favorites-grid]');
    const count = page.querySelector('[data-squizy-favorites-count]');
    const empty = page.querySelector('[data-squizy-favorites-empty]');
    const productRoot = window.Shopify?.routes?.root || '/';

    const escapeHtml = (value) =>
      String(value).replace(/[&<>'"]/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#039;',
        '"': '&quot;',
      })[character]);

    const readFavorites = () => {
      try {
        const favorites = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(favorites) ? favorites : [];
      } catch {
        return [];
      }
    };

    const formatPrice = (price) =>
      new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }).format(price / 100);

    const renderFavorites = async () => {
      const handles = readFavorites();
      grid.replaceChildren();
      count.textContent = handles.length ? `${handles.length} favori${handles.length > 1 ? 's' : ''}` : '';
      empty.hidden = handles.length > 0;

      if (!handles.length) return;

      const products = await Promise.all(
        handles.map(async (handle) => {
          try {
            const response = await fetch(`${productRoot}products/${encodeURIComponent(handle)}.js`);
            return response.ok ? response.json() : null;
          } catch {
            return null;
          }
        })
      );

      products.filter(Boolean).forEach((product) => {
        const textureTag = product.tags.find((tag) => tag.toLowerCase() !== 'nouveautés');
        const image = product.featured_image || '';
        const canQuickAdd = product.available && product.variants.length === 1;
        const card = document.createElement('article');
        card.className = 'squizy-product-card squizy-product-card--white';
        card.innerHTML = `
          <button class="squizy-product-card__favorite is-favorite" type="button" data-squizy-favorite data-product-handle="${escapeHtml(product.handle)}" aria-pressed="true" aria-label="Retirer des favoris">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>
          </button>
          <a class="squizy-product-card__media" href="${escapeHtml(product.url)}" aria-label="${escapeHtml(product.title)}">
            <span class="squizy-product-card__media-orb">${image ? `<img class="squizy-product-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}">` : ''}</span>
          </a>
          <div class="squizy-product-card__content">
            <p class="squizy-product-card__kicker"><span>${escapeHtml(product.type || 'Squishy')}</span>${textureTag ? `<span class="squizy-product-card__kicker-separator" aria-hidden="true">·</span><span>${escapeHtml(textureTag)}</span>` : ''}</p>
            <h2 class="squizy-product-card__title"><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h2>
            <div class="squizy-product-card__footer">
              <div class="squizy-product-card__price"><span>${formatPrice(product.price)}</span></div>
              <div class="squizy-product-card__actions">
                ${canQuickAdd ? `<button class="squizy-product-card__add-button" type="button" data-squizy-favorite-add data-variant-id="${product.variants[0].id}" aria-label="Ajouter ${escapeHtml(product.title)} au panier"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg></button>` : ''}
                <a class="squizy-product-card__link" href="${escapeHtml(product.url)}" aria-label="Voir ${escapeHtml(product.title)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>
              </div>
            </div>
          </div>
        `;
        grid.append(card);
      });
    };

    document.addEventListener('squizy:favorites-updated', renderFavorites);
    grid.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-squizy-favorite-add]');
      if (!button || button.disabled) return;

      button.disabled = true;

      try {
        const response = await fetch(`${productRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
        });

        if (!response.ok) throw new Error('Unable to add the product to the cart.');

        const cartResponse = await fetch(`${productRoot}cart.js`);
        const cart = await cartResponse.json();
        const cartSection = document.querySelector('#cart-icon-bubble .shopify-section');
        let cartCount = cartSection?.querySelector('.squizy-header__cart-count');

        if (cartSection && !cartCount && cart.item_count > 0) {
          cartCount = document.createElement('span');
          cartCount.className = 'squizy-header__cart-count';
          cartCount.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartSection.append(cartCount);
        }

        if (cartCount) {
          cartCount.querySelector('[aria-hidden="true"]').textContent = cart.item_count;
        }

        button.classList.add('is-added');
      } catch {
        button.disabled = false;
        return;
      }

      window.setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-added');
      }, 900);
    });
    renderFavorites();
  });

  document.querySelectorAll('[data-squizy-coffrets-composer]').forEach((composer) => {
    const box = composer.querySelector('.squizy-coffrets__box');
    const products = Array.from(composer.querySelectorAll('[data-squizy-coffrets-product]'));
    const productsPanel = composer.querySelector('[data-squizy-coffrets-products]');
    const pickerBackdrop = composer.querySelector('[data-squizy-coffrets-picker-backdrop]');
    const pickerClose = composer.querySelector('[data-squizy-coffrets-picker-close]');
    const mobilePicker = window.matchMedia('(max-width: 749px)');
    const slots = Array.from(composer.querySelectorAll('[data-squizy-coffrets-slot]'));
    const price = composer.querySelector('[data-squizy-coffrets-price]');
    const note = composer.querySelector('[data-squizy-coffrets-note]');
    const noteSave = composer.querySelector('[data-squizy-coffrets-note-save]');
    const noteStatus = composer.querySelector('[data-squizy-coffrets-note-status]');
    const savedNotePreview = composer.querySelector('[data-squizy-coffrets-saved-note]');
    const originalPrice = composer.querySelector('[data-squizy-coffrets-original-price]');
    const submit = composer.querySelector('[data-squizy-coffrets-submit]');
    const reset = composer.querySelector('[data-squizy-coffrets-reset]');
    const progress = Array.from(composer.querySelectorAll('[data-squizy-coffrets-progress]'));
    const configuredDiscount = Number(composer.dataset.squizyDiscountPercent);
    const discountPercent = Number.isFinite(configuredDiscount) && configuredDiscount >= 0 && configuredDiscount <= 50
      ? configuredDiscount
      : 10;
    const foxsellParentVariant = Number(composer.dataset.foxsellParentVariant);
    const foxsellReady = composer.dataset.squizyBundleBackend === 'foxsell' && Number.isSafeInteger(foxsellParentVariant) && foxsellParentVariant > 0;
    const devFunctionReady = composer.dataset.squizyBundleBackend === 'dev-function';
    const selections = [null, null, null];
    let draggedProduct = null;
    let dragPreview = null;
    let draggingButton = null;
    let nativeDragImage = null;
    let wasComplete = false;
    let savedNote = '';
    let activeSlotIndex = null;
    let pickerOpener = null;
    let placingProduct = false;

    if (productsPanel) productsPanel.inert = mobilePicker.matches;

    const closePicker = () => {
      productsPanel?.classList.remove('is-open');
      pickerBackdrop?.classList.remove('is-open');
      if (productsPanel) {
        productsPanel.inert = mobilePicker.matches;
        productsPanel.removeAttribute('role');
        productsPanel.removeAttribute('aria-modal');
      }
      document.body.classList.remove('overflow-hidden');
      pickerOpener?.focus();
      pickerOpener = null;
      activeSlotIndex = null;
    };

    const openPicker = (index, slot) => {
      if (!productsPanel || !mobilePicker.matches) return;
      activeSlotIndex = index;
      pickerOpener = slot;
      productsPanel.inert = false;
      productsPanel.setAttribute('role', 'dialog');
      productsPanel.setAttribute('aria-modal', 'true');
      productsPanel.classList.add('is-open');
      pickerBackdrop?.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      pickerClose?.focus();
    };

    const flyProductToSlot = (button, slot) => {
      if (!button.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
      const source = button.getBoundingClientRect();
      const destination = slot.getBoundingClientRect();
      const flyingCard = button.cloneNode(true);
      flyingCard.classList.add('squizy-coffrets__flying-product');
      flyingCard.removeAttribute('data-squizy-coffrets-product');
      flyingCard.removeAttribute('draggable');
      flyingCard.setAttribute('aria-hidden', 'true');
      flyingCard.tabIndex = -1;
      document.body.append(flyingCard);

      const scale = Math.min(destination.width / source.width, destination.height / source.height);
      const targetX = destination.left + (destination.width - source.width) / 2;
      const targetY = destination.top + (destination.height - source.height) / 2;
      const rotation = Number.parseFloat(getComputedStyle(slot).rotate) || 0;
      const halfwayX = source.left + (targetX - source.left) * 0.55;
      const halfwayY = source.top + (targetY - source.top) * 0.55 - 1.8 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      const animation = flyingCard.animate([
        { transform: `translate(${source.left}px, ${source.top}px) rotate(0deg) scale(1)`, width: `${source.width}px`, height: `${source.height}px` },
        { transform: `translate(${halfwayX}px, ${halfwayY}px) rotate(${rotation * 0.55}deg) scale(${1 + (scale - 1) * 0.55})`, width: `${source.width}px`, height: `${source.height}px`, offset: 0.55 },
        {
          transform: `translate(${targetX}px, ${targetY}px) rotate(${rotation}deg) scale(${scale})`,
          width: `${source.width}px`,
          height: `${source.height}px`,
        },
      ], { duration: 620, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
      return { animation, flyingCard };
    };

    pickerClose?.addEventListener('click', closePicker);
    pickerBackdrop?.addEventListener('click', closePicker);
    productsPanel?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePicker();
      if (event.key !== 'Tab') return;
      const focusable = [pickerClose, ...products.filter((product) => !product.disabled)].filter(Boolean);
      if (event.shiftKey && document.activeElement === focusable[0]) {
        event.preventDefault();
        focusable.at(-1)?.focus();
      } else if (!event.shiftKey && document.activeElement === focusable.at(-1)) {
        event.preventDefault();
        focusable[0]?.focus();
      }
    });
    mobilePicker.addEventListener('change', () => closePicker());

    const formatPrice = (amount) =>
      new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }).format(amount / 100);

    const productFromButton = (button) => ({
      title: button.dataset.productTitle,
      type: button.dataset.productType,
      variantId: Number(button.dataset.productVariantId),
      price: Number(button.dataset.productPrice),
      image: button.dataset.productImage,
    });

    const moveDragPreview = (event) => {
      if (!dragPreview) return;

      const x = event.clientX || 0;
      const y = event.clientY || 0;

      if (!x && !y) return;

      dragPreview.style.setProperty('--squizy-drag-x', `${x - dragPreview.offsetWidth * 0.48}px`);
      dragPreview.style.setProperty('--squizy-drag-y', `${y - dragPreview.offsetHeight * 0.38}px`);
    };

    const clearDragPreview = () => {
      draggingButton?.classList.remove('is-dragging');
      dragPreview?.remove();
      nativeDragImage?.remove();
      draggingButton = null;
      dragPreview = null;
      nativeDragImage = null;
      draggedProduct = null;
    };

    const createDragPreview = (button, event) => {
      const sourceRect = button.getBoundingClientRect();
      const card = button.cloneNode(true);
      const preview = document.createElement('div');

      card.removeAttribute('draggable');
      card.removeAttribute('data-squizy-coffrets-product');
      card.classList.remove('is-dragging');
      card.setAttribute('aria-hidden', 'true');
      card.tabIndex = -1;

      preview.className = 'squizy-coffrets__drag-preview';
      preview.style.width = `${sourceRect.width}px`;
      preview.style.setProperty('--squizy-drag-x', `${event.clientX - sourceRect.width * 0.48}px`);
      preview.style.setProperty('--squizy-drag-y', `${event.clientY - sourceRect.height * 0.38}px`);
      preview.append(card);
      document.body.append(preview);

      return preview;
    };

    const escapeHtml = (value) => String(value).replace(/[&<>'\"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;',
    })[character]);

    const renderComposer = () => {
      const selectedCount = selections.filter(Boolean).length;
      const total = selections.reduce((sum, selection) => sum + (selection?.price || 0), 0);
      const selectedDiscount = Math.round(total * discountPercent / 100);
      const isComplete = selectedCount === 3;

      box?.classList.toggle('is-complete', isComplete);
      if (!isComplete) box?.classList.remove('is-celebrating');

      if (isComplete && !wasComplete && box) {
        box.classList.remove('is-celebrating');
        void box.offsetWidth;
        box.classList.add('is-celebrating');
        window.setTimeout(() => box.classList.remove('is-celebrating'), 1400);
      }

      wasComplete = isComplete;

      slots.forEach((slot, index) => {
        const selection = selections[index];
        slot.classList.toggle('is-filled', Boolean(selection));
        progress[index].classList.toggle('is-selected', Boolean(selection));
        progress[index].setAttribute('aria-label', selection ? `${selection.title} ajoutée` : 'Pièce à choisir');

        if (selection) {
          slot.innerHTML = selection.image
            ? `<article class="squizy-coffrets__product squizy-coffrets__selected-card">
                <span class="squizy-coffrets__product-image"><img src="${escapeHtml(selection.image)}" alt="${escapeHtml(selection.title)}"></span>
                <span class="squizy-coffrets__product-type">${escapeHtml(selection.type)}</span>
                <span class="squizy-coffrets__product-title">${escapeHtml(selection.title)}</span>
                <span class="squizy-coffrets__product-price">${formatPrice(selection.price)}</span>
              </article>`
            : `<article class="squizy-coffrets__product squizy-coffrets__selected-card">
                <span class="squizy-coffrets__product-type">${escapeHtml(selection.type)}</span>
                <span class="squizy-coffrets__product-title">${escapeHtml(selection.title)}</span>
                <span class="squizy-coffrets__product-price">${formatPrice(selection.price)}</span>
              </article>`;
          slot.setAttribute('aria-label', `Retirer ${selection.title}`);
        } else {
          slot.innerHTML = '<span><b>+</b></span>';
          slot.setAttribute('aria-label', 'Ajouter une pièce');
        }
      });

      if (isComplete) {
        originalPrice.hidden = false;
        originalPrice.textContent = formatPrice(total);
        price.textContent = formatPrice(Math.max(0, total - selectedDiscount));
        submit.disabled = !foxsellReady && !devFunctionReady;
        submit.textContent = submit.disabled ? 'Bientôt disponible' : 'Ajouter au panier';
      } else {
        const remaining = 3 - selectedCount;
        originalPrice.hidden = selectedCount === 0;
        originalPrice.textContent = selectedCount ? formatPrice(total) : '';
        price.textContent = formatPrice(Math.max(0, total - selectedDiscount));
        submit.disabled = true;
        submit.textContent = `Encore ${remaining} pièce${remaining > 1 ? 's' : ''}`;
      }
    };

    const placeProduct = (product, slotIndex) => {
      if (!product || slotIndex < 0 || slotIndex > 2) return;
      selections[slotIndex] = product;
      renderComposer();
    };

    const resetComposer = () => {
      selections.fill(null);
      if (note) note.value = '';
      if (noteStatus) noteStatus.textContent = '';
      savedNote = '';
      if (savedNotePreview) {
        savedNotePreview.hidden = true;
        savedNotePreview.textContent = '';
      }
      if (noteSave) noteSave.textContent = 'Ajouter';
      renderComposer();
    };

    products.forEach((productButton) => {
      productButton.querySelectorAll('img').forEach((image) => {
        image.draggable = false;
      });

      productButton.addEventListener('click', () => {
        if (mobilePicker.matches && activeSlotIndex !== null) {
          const slotIndex = activeSlotIndex;
          const chosenSlot = slots[slotIndex];
          const selection = productFromButton(productButton);
          const flight = flyProductToSlot(productButton, chosenSlot);
          if (flight) {
            placingProduct = true;
            box?.setAttribute('aria-busy', 'true');
            productButton.classList.add('is-being-picked');
          }
          closePicker();
          if (flight) {
            flight.animation.finished.catch(() => {}).then(() => {
              placeProduct(selection, slotIndex);
              flight.flyingCard.remove();
              productButton.classList.remove('is-being-picked');
              placingProduct = false;
              box?.removeAttribute('aria-busy');
            });
          } else {
            placeProduct(selection, slotIndex);
          }
          return;
        }
        const emptyIndex = selections.findIndex((selection) => selection === null);
        placeProduct(productFromButton(productButton), emptyIndex === -1 ? 2 : emptyIndex);
      });

      productButton.addEventListener('dragstart', (event) => {
        draggedProduct = productFromButton(productButton);
        draggingButton = productButton;
        draggingButton.classList.add('is-dragging');
        dragPreview = createDragPreview(productButton, event);

        if (event.dataTransfer) {
          nativeDragImage = document.createElement('canvas');
          nativeDragImage.width = 1;
          nativeDragImage.height = 1;
          nativeDragImage.style.position = 'fixed';
          nativeDragImage.style.top = '-1px';
          nativeDragImage.style.left = '-1px';
          nativeDragImage.style.opacity = '0';
          document.body.append(nativeDragImage);
          event.dataTransfer.effectAllowed = 'copy';
          event.dataTransfer.setData('text/plain', productButton.dataset.productHandle || 'squizy-product');
          event.dataTransfer.setDragImage(nativeDragImage, 0, 0);
        }
      });

      productButton.addEventListener('drag', moveDragPreview);
      productButton.addEventListener('dragend', clearDragPreview);
    });

    slots.forEach((slot, index) => {
      slot.addEventListener('dragover', (event) => {
        event.preventDefault();
        slot.classList.add('is-dragging-over');
      });

      slot.addEventListener('dragleave', () => slot.classList.remove('is-dragging-over'));

      slot.addEventListener('drop', (event) => {
        event.preventDefault();
        slot.classList.remove('is-dragging-over');
        placeProduct(draggedProduct, index);
        clearDragPreview();
      });
    });

    document.addEventListener('dragover', moveDragPreview);

    composer.addEventListener('click', (event) => {
      const slot = event.target.closest('[data-squizy-coffrets-slot]');
      if (!slot || !composer.contains(slot)) return;
      if (placingProduct) return;

      const index = Number(slot.dataset.squizyCoffretsSlot);
      if (selections[index]) {
        selections[index] = null;
        renderComposer();
      } else if (mobilePicker.matches) {
        openPicker(index, slot);
      } else if (productsPanel) {
        productsPanel.classList.remove('is-attention');
        void productsPanel.offsetWidth;
        productsPanel.classList.add('is-attention');
      }
    });

    noteSave?.addEventListener('click', () => {
      if (!noteStatus) return;
      const value = note?.value.trim() || '';

      if (!value) {
        noteStatus.textContent = 'Écris un petit mot avant de l’ajouter.';
        return;
      }

      savedNote = value;
      noteStatus.textContent = 'Mot ajouté au coffret 💌';
      noteSave.textContent = 'Modifier le mot';
      if (savedNotePreview) {
        savedNotePreview.textContent = `« ${savedNote} »`;
        savedNotePreview.hidden = false;
      }
    });

    reset?.addEventListener('click', resetComposer);

    submit.addEventListener('click', async () => {
      if (submit.disabled || selections.some((selection) => !selection)) return;

      submit.disabled = true;
      submit.textContent = 'Ajout en cours…';

      const bundleId = window.crypto?.randomUUID?.() || `squizy-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      let cartItems;

      if (foxsellReady) {
        const components = [];
        selections.forEach((selection) => {
          const existing = components.find((component) => component.variantId === selection.variantId);
          if (existing) {
            existing.quantity += 1;
          } else {
            components.push({
              variantId: selection.variantId,
              quantity: 1,
              category: composer.dataset.foxsellCategory || 'Squishies',
              type: 'product',
              ...(savedNote && components.length === 0 ? { properties: { 'Mot pour l’emballage': savedNote } } : {}),
            });
          }
        });

        cartItems = [{
          id: foxsellParentVariant,
          quantity: 1,
          properties: {
            '__foxsell:dynamic_add_on_bundle_id': `${composer.dataset.foxsellBundleId}_${Date.now()}`,
            '__foxsell:dynamic_add_on_bundle_items': JSON.stringify(components),
            ...Object.fromEntries(selections.map((selection, index) => [`Pièce ${index + 1}`, selection.title])),
            ...Object.fromEntries(selections.map((selection, index) => [`_squizy_piece_${index + 1}_image`, selection.image || ''])),
            ...(savedNote ? { 'Mot pour l’emballage': savedNote } : {}),
          },
        }];
      } else {
        const bundleProperties = {
          squizy_bundle_id: bundleId,
          ...(savedNote ? { squizy_bundle_note: savedNote } : {}),
        };
        cartItems = selections.map((selection) => ({
          id: selection.variantId,
          quantity: 1,
          properties: bundleProperties,
        }));
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: cartItems }),
        });

        if (!response.ok) throw new Error('Unable to add composer items to cart.');

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await cartResponse.json();
        const cartSection = document.querySelector('#cart-icon-bubble .shopify-section');
        let cartCount = cartSection?.querySelector('.squizy-header__cart-count');

        if (cartSection && !cartCount && cart.item_count > 0) {
          cartCount = document.createElement('span');
          cartCount.className = 'squizy-header__cart-count';
          cartCount.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartSection.append(cartCount);
        }

        if (cartCount) {
          cartCount.querySelector('[aria-hidden="true"]').textContent = cart.item_count;
        }

        submit.textContent = 'Ajouté au panier';
      } catch {
        submit.disabled = false;
        submit.textContent = 'Réessayer';
      }
    });

    renderComposer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-squizy-product-tabs]').forEach((tabs) => {
    const descriptionCopy = tabs.querySelector('[data-squizy-product-description-copy]');
    const featuresCopy = tabs.querySelector('[data-squizy-product-features-copy]');
    const safetyCopy = tabs.querySelector('[data-squizy-product-safety-copy]');
    const normalize = (value) => value.trim().toLocaleLowerCase('fr-FR')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[:\s]+$/g, '').replace(/\s+/g, ' ');
    const headingTarget = (value) => {
      const heading = normalize(value);
      if (heading === 'description') return descriptionCopy;
      if (/^caracteristiques?$/.test(heading)) return featuresCopy;
      if (/^(informations? de securite|securite)$/.test(heading)) return safetyCopy;
      return null;
    };

    if (descriptionCopy && featuresCopy && safetyCopy) {
      let currentCopy = descriptionCopy;
      let foundHeading = false;
      Array.from(descriptionCopy.children).forEach((element) => {
        const headingText = element.matches('h1, h2, h3, h4')
          ? element.textContent
          : element.querySelector('strong, b')?.textContent || element.textContent;
        const target = headingText ? headingTarget(headingText) : null;
        if (target) {
          foundHeading = true;
          currentCopy = target;
          if (normalize(element.textContent) === normalize(headingText)) {
            element.remove();
            return;
          }
        }
        if (currentCopy !== descriptionCopy) {
          if (currentCopy.hasAttribute('data-squizy-has-metafield')) element.remove();
          else currentCopy.append(element);
        }
      });

      if (!foundHeading) {
        Array.from(descriptionCopy.children).forEach((element) => {
          const content = normalize(element.textContent).replace(/^[^\p{L}⚠]+/u, '');
          const target = /^(taille|poids|couleur|matiere|texture|effet|design|particularite)\b/.test(content)
            ? featuresCopy
            : content.startsWith('⚠') || /^(des? \d+ ans|conforme|ne convient pas|pour plus de details)/.test(content)
              ? safetyCopy
              : null;
          if (!target) return;
          if (target.hasAttribute('data-squizy-has-metafield')) element.remove();
          else target.append(element);
        });
      }
    }

    tabs.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetPanel = tabs.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (!targetPanel) return;

        tabs.querySelectorAll('[role="tab"]').forEach((otherTab) => {
          const isActive = otherTab === tab;
          otherTab.classList.toggle('is-active', isActive);
          otherTab.setAttribute('aria-selected', String(isActive));
        });

        tabs.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
          const isActive = panel === targetPanel;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  });

  document.querySelectorAll('[data-squizy-buy-now]').forEach((button) => {
    button.addEventListener('click', async () => {
      const form = button.closest('form');
      if (!form || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${button.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) throw new Error('Unable to add the product to the cart.');

        window.location.assign(button.dataset.checkoutUrl);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squizy-collection-products"]) return;
  try {
    
  document.querySelectorAll('.squizy-collection-products__sidebar').forEach((sidebar) => {
    const toggle = sidebar.querySelector('[data-squizy-filters-toggle]');
    const close = sidebar.querySelector('[data-squizy-filters-close]');
    const panel = sidebar.querySelector('[data-squizy-filters-panel]');
    if (!toggle || !panel) return;

    const setOpen = (open) => {
      sidebar.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      panel.inert = !open && window.matchMedia('(max-width: 749px)').matches;
    };

    toggle.addEventListener('click', () => setOpen(!sidebar.classList.contains('is-open')));
    close?.addEventListener('click', () => {
      setOpen(false);
      sidebar.closest('.squizy-collection-products')?.querySelector('.squizy-collection-products__grid')?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
    window.matchMedia('(max-width: 749px)').addEventListener('change', () => setOpen(false));
    setOpen(false);
  });

  document.querySelectorAll('.squizy-collection-products').forEach((section) => {
    const form = section.querySelector('[data-squizy-collection-filter-form]');
    const cards = Array.from(section.querySelectorAll('.squizy-collection-products__grid .squizy-product-card'));
    const count = section.querySelector('[data-squizy-visible-count]');
    const empty = section.querySelector('[data-squizy-filter-empty]');
    if (!form || !cards.length || !count) return;

    const url = new URL(window.location.href);
    if (url.searchParams.has('filter.v.availability')) {
      url.searchParams.delete('filter.v.availability');
      window.location.replace(url.toString());
      return;
    }

    const kindInputs = Array.from(form.querySelectorAll('input[name="squizy_kind"]'));
    const stockInputs = Array.from(form.querySelectorAll('input[name="squizy_stock"]'));
    const kind = url.searchParams.get('squizy_kind');
    const stock = url.searchParams.get('squizy_stock');
    (kindInputs.find((input) => input.value === kind) || kindInputs[0]).checked = true;
    (stockInputs.find((input) => input.value === stock) || stockInputs[0]).checked = true;

    const applyFilters = () => {
      const selectedKind = kindInputs.find((input) => input.checked)?.value || 'individual';
      const selectedStock = stockInputs.find((input) => input.checked)?.value || 'available';
      let visibleCount = 0;

      cards.forEach((card) => {
        const kindMatches = selectedKind === 'all' || card.dataset.squizyProductKind === selectedKind;
        const stockMatches = selectedStock === 'all' || card.dataset.squizyProductAvailable === 'true';
        card.hidden = !kindMatches || !stockMatches;
        if (!card.hidden) visibleCount += 1;
      });

      count.textContent = `${visibleCount} ${visibleCount === 1 ? 'produit' : 'produits'}`;
      if (empty) empty.hidden = visibleCount > 0;

      const nextUrl = new URL(window.location.href);
      if (selectedKind === 'individual') nextUrl.searchParams.delete('squizy_kind');
      else nextUrl.searchParams.set('squizy_kind', selectedKind);
      if (selectedStock === 'available') nextUrl.searchParams.delete('squizy_stock');
      else nextUrl.searchParams.set('squizy_stock', selectedStock);
      window.history.replaceState({}, '', nextUrl.toString());
    };

    [...kindInputs, ...stockInputs].forEach((input) => input.addEventListener('change', applyFilters));
    applyFilters();
  });

  document.querySelectorAll('[data-squizy-collection-filter-form]').forEach((form) => {
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => form.requestSubmit());
    });
  });

  document.querySelectorAll('[data-squizy-collection-sort-form]').forEach((form) => {
    const select = form.querySelector('select[name="squizy_sort_type"]');
    const directionButton = form.querySelector('[data-squizy-sort-direction]');
    const sortValues = {
      'best-selling': { ascending: 'best-selling', descending: 'best-selling' },
      manual: { ascending: 'manual', descending: 'manual' },
      title: { ascending: 'title-ascending', descending: 'title-descending' },
      price: { ascending: 'price-ascending', descending: 'price-descending' },
      created: { ascending: 'created-ascending', descending: 'created-descending' },
    };
    let direction = directionButton.classList.contains('is-ascending') ? 'ascending' : 'descending';

    const canChangeDirection = () => ['title', 'price', 'created'].includes(select.value);
    const updateDirectionButton = () => {
      directionButton.disabled = !canChangeDirection();
      directionButton.classList.toggle('is-ascending', direction === 'ascending');
      directionButton.classList.toggle('is-descending', direction === 'descending');
      directionButton.setAttribute(
        'aria-label',
        direction === 'ascending' ? 'Tri croissant' : 'Tri décroissant'
      );
    };
    const applySort = () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValues[select.value][direction]);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    };

    select.addEventListener('change', () => {
      updateDirectionButton();
      applySort();
    });

    directionButton.addEventListener('click', () => {
      if (!canChangeDirection()) return;

      direction = direction === 'ascending' ? 'descending' : 'ascending';
      updateDirectionButton();
      applySort();
    });

    updateDirectionButton();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squizy-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.squizy-header__mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squizy-hero"] && !Shopify.designMode) return;
  try {
    
  const squizyParallaxClasses = {
    x: [
      'squizy-parallax-x--far-left',
      'squizy-parallax-x--left',
      'squizy-parallax-x--center',
      'squizy-parallax-x--right',
      'squizy-parallax-x--far-right'
    ],
    y: [
      'squizy-parallax-y--far-top',
      'squizy-parallax-y--top',
      'squizy-parallax-y--center',
      'squizy-parallax-y--bottom',
      'squizy-parallax-y--far-bottom'
    ]
  };

  const squizyParallaxStep = (value) => Math.min(4, Math.max(0, Math.floor(value * 5)));

  document.querySelectorAll('[data-squizy-parallax]').forEach((hero) => {
    const canMove = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const accents = hero.querySelectorAll('[data-squizy-hero-accent]');

    if (reduceMotion) return;

    let frame;

    const setPosition = (x, y) => {
      hero.classList.remove(...squizyParallaxClasses.x, ...squizyParallaxClasses.y);
      hero.classList.add(squizyParallaxClasses.x[squizyParallaxStep(x)]);
      hero.classList.add(squizyParallaxClasses.y[squizyParallaxStep(y)]);
      accents.forEach((accent) => {
        const sensitivity = Number.parseFloat(getComputedStyle(accent).getPropertyValue('--squizy-accent-parallax')) || 0;
        accent.style.setProperty('--squizy-accent-shift-x', `${(x - 0.5) * 3 * sensitivity}rem`);
        accent.style.setProperty('--squizy-accent-shift-y', `${(y - 0.5) * 2 * sensitivity}rem`);
      });
    };

    if (canMove) {
      hero.addEventListener('pointermove', (event) => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const bounds = hero.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width;
          const y = (event.clientY - bounds.top) / bounds.height;
          setPosition(x, y);
        });
      });

      hero.addEventListener('pointerleave', () => setPosition(0.5, 0.5));
      return;
    }

    if (!window.matchMedia('(max-width: 749px) and (pointer: coarse)').matches || !window.isSecureContext || !window.DeviceOrientationEvent) return;

    let firstBeta;
    let firstGamma;
    let heroVisible = true;

    new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
    }).observe(hero);

    const onOrientation = ({ beta, gamma }) => {
      if (!heroVisible || !Number.isFinite(beta) || !Number.isFinite(gamma)) return;
      if (firstBeta === undefined) {
        firstBeta = beta;
        firstGamma = gamma;
      }

      const x = 0.5 + Math.max(-1, Math.min(1, (gamma - firstGamma) / 25)) * 0.28;
      const y = 0.5 + Math.max(-1, Math.min(1, (beta - firstBeta) / 25)) * 0.28;
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setPosition(x, y));
    };

    const startOrientation = () => window.addEventListener('deviceorientation', onOrientation, { passive: true });
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      let requested = false;
      hero.addEventListener('click', async (event) => {
        if (requested || event.target.closest('a, button')) return;
        requested = true;
        try {
          if (await DeviceOrientationEvent.requestPermission() === 'granted') startOrientation();
        } catch (_) {
          setPosition(0.5, 0.5);
        }
      });
    } else {
      startOrientation();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squizy-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.squizy-product-reviews').forEach((section) => {
    const widget = section.querySelector('.jdgm-review-widget');
    const empty = section.querySelector('[data-squizy-reviews-empty]');
    if (!widget || !empty) return;

    const syncEmpty = () => {
      empty.hidden = Array.from(widget.children).some((child) =>
        !child.classList.contains('jdgm-legacy-widget-content')
      );
    };

    syncEmpty();
    new MutationObserver(syncEmpty).observe(widget, { childList: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squizy-shortcuts"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.squizy-shortcuts__card[href="#squizy-club"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const club = document.getElementById('squizy-club');
      if (!club) return;

      event.preventDefault();
      if (window.location.hash !== '#squizy-club') window.history.pushState(null, '', '#squizy-club');
      club.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squizy-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('squizy-video-carousel')) {
    class SquizyVideoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = Array.from(this.querySelectorAll('[data-video-url]'));
        this.index = 0;
        this.muted = true;
        this.visible = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.reducedMotion;
        this.autoAdvance = this.dataset.autoAdvance === 'true' && !this.reducedMotion && !window.Shopify?.designMode;
        this.viewport = this.querySelector('.squizy-videos__viewport');
        this.deck = this.querySelector('.squizy-videos__deck');
        this.cards.forEach((card) => {
          try {
            const url = new URL(card.dataset.videoUrl);
            if (url.protocol !== 'https:' || !(url.hostname === 'tiktok.com' || url.hostname.endsWith('.tiktok.com'))) throw new Error('Invalid host');
            card.videoId = url.pathname.match(/\/(?:video|player\/v1)\/(\d+)/)?.[1];
          } catch { card.videoId = null; }
          if (!card.videoId) this.fail(card, true);
        });
        this.dataset.enhanced = '';
        this.render(false);
        this.addEventListener('click', (event) => this.handleClick(event), options);
        this.viewport.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const cards = this.availableCards();
          if (event.key === 'Home') this.select(0, true);
          else if (event.key === 'End') this.select(cards.length - 1, true);
          else this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }, options);
        this.viewport.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0 || !(event.target.closest('[data-video-action]') || event.target === this.deck || event.target === this.viewport)) return;
          const target = event.target.closest('[data-video-action]') || this.viewport;
          this.drag = { id: event.pointerId, target, x: event.clientX, y: event.clientY, dx: 0, horizontal: false };
          target.setPointerCapture(event.pointerId);
        }, options);
        this.viewport.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          if (!this.drag.horizontal && Math.abs(dx) > 9 && Math.abs(dx) > Math.abs(dy)) {
            this.drag.horizontal = true;
          }
          if (!this.drag.horizontal) return;
          event.preventDefault();
          this.drag.dx = dx;
          this.classList.add('is-dragging');
          this.deck.style.setProperty('--squizy-video-drag', `${Math.max(-110, Math.min(110, dx))}px`);
        }, options);
        const endDrag = (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const drag = this.drag;
          this.drag = null;
          if (drag.target.hasPointerCapture(event.pointerId)) drag.target.releasePointerCapture(event.pointerId);
          this.classList.remove('is-dragging');
          this.deck.style.removeProperty('--squizy-video-drag');
          if (drag.horizontal) {
            this.suppressClick = true;
            clearTimeout(this.suppressTimer);
            this.suppressTimer = setTimeout(() => { this.suppressClick = false; }, 120);
            if (event.type !== 'pointercancel' && Math.abs(drag.dx) > 40) this.select(this.index + (drag.dx < 0 ? 1 : -1), true);
          }
        };
        this.viewport.addEventListener('pointerup', endDrag, options);
        this.viewport.addEventListener('pointercancel', endDrag, options);
        window.addEventListener('message', (event) => this.handleMessage(event), options);
        document.addEventListener('visibilitychange', () => this.checkVisibility(), options);
        const scheduleVisibility = () => {
          if (this.visibilityFrame) return;
          this.visibilityFrame = requestAnimationFrame(() => {
            this.visibilityFrame = null;
            this.checkVisibility();
          });
        };
        window.addEventListener('scroll', scheduleVisibility, { ...options, passive: true });
        window.addEventListener('resize', scheduleVisibility, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.availableCards().findIndex((card) => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index, true);
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.render(false);
          this.syncPlayback();
        }, { threshold: 0.2 });
        this.observer.observe(this);
        scheduleVisibility();
      }

      disconnectedCallback() {
        this.cards?.forEach((card) => {
          this.send(card, 'mute');
          this.send(card, 'pause');
          clearTimeout(card.loadTimer);
          cancelAnimationFrame(card.recycleFrame);
        });
        clearTimeout(this.suppressTimer);
        cancelAnimationFrame(this.visibilityFrame);
        this.visibilityFrame = null;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }

      availableCards() { return this.cards.filter((card) => !card.hidden); }

      checkVisibility() {
        const rect = this.getBoundingClientRect();
        const visible = !document.hidden && rect.bottom > 0 && rect.top < window.innerHeight;
        if (visible !== this.visible) {
          this.visible = visible;
          if (visible) this.render(false);
          else this.syncPlayback();
        }
      }

      send(card, type) {
        card?.frame?.contentWindow?.postMessage({ type, 'x-tiktok-player': true }, 'https://www.tiktok.com');
      }

      load(card) {
        if (card.frame || !card.videoId) return;
        card.dataset.state = 'loading';
        card.querySelector('[data-video-status]').textContent = this.dataset.loadingLabel;
        const iframe = document.createElement('iframe');
        const params = new URLSearchParams({ autoplay: '1', controls: '0', progress_bar: '0', play_button: '0', volume_control: '0', fullscreen_button: '0', timestamp: '0', description: '0', music_info: '0', rel: '0', loop: '0', muted: '1' });
        iframe.src = `https://www.tiktok.com/player/v1/${card.videoId}?${params}`;
        iframe.title = card.dataset.videoTitle;
        iframe.allow = 'autoplay; fullscreen';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.tabIndex = card.dataset.position === '0' ? 0 : -1;
        iframe.addEventListener('load', () => {
          if (card.frame !== iframe || card.ready || card.hidden) return;
          clearTimeout(card.loadTimer);
          card.dataset.state = 'loaded';
          card.loadTimer = setTimeout(() => {
            if (card.ready || card.hidden) return;
            card.dataset.state = 'stalled';
            card.querySelector('[data-video-status]').textContent = this.dataset.failedLabel;
          }, 25000);
        }, { signal: this.controller.signal });
        card.frame = iframe;
        card.ready = false;
        delete card.dataset.ready;
        card.querySelector('.squizy-videos__player').append(iframe);
        card.loadTimer = setTimeout(() => { if (!card.ready) this.fail(card, false); }, 18000);
      }

      fail(card, unavailable) {
        if (!card) return;
        clearTimeout(card.loadTimer);
        this.send(card, 'pause');
        card.classList.remove('is-playing');
        card.dataset.state = unavailable ? 'unavailable' : 'failed';
        card.querySelector('[data-video-status]').textContent = unavailable ? this.dataset.unavailableLabel : this.dataset.failedLabel;
        if (unavailable && !window.Shopify?.designMode) {
          const focusWasInside = card.contains(document.activeElement);
          card.hidden = true;
          if (this.isConnected && this.dataset.enhanced !== undefined) this.render(false);
          if (focusWasInside) this.viewport?.focus({ preventScroll: true });
        }
      }

      render(announce) {
        const cards = this.availableCards();
        if (!cards.length) { this.hidden = !window.Shopify?.designMode; return; }
        this.hidden = false;
        this.index = ((this.index % cards.length) + cards.length) % cards.length;
        cards.forEach((card, index) => {
          let offset = index - this.index;
          if (offset > cards.length / 2) offset -= cards.length;
          if (offset < -cards.length / 2) offset += cards.length;
          const previous = card.dataset.position;
          const recycling = previous !== undefined && Math.abs(offset - Number(previous)) > cards.length / 2;
          if (recycling) card.classList.add('is-recycling');
          card.dataset.position = String(offset);
          card.toggleAttribute('data-distant', Math.abs(offset) > 2);
          card.inert = Math.abs(offset) > 2;
          if (card.classList.contains('is-recycling')) {
            cancelAnimationFrame(card.recycleFrame);
            void card.offsetWidth;
            card.recycleFrame = requestAnimationFrame(() => card.classList.remove('is-recycling'));
          }
          card.querySelector('[data-video-action]').setAttribute('aria-label', offset === 0 ? this.dataset.playLabel : this.positionText(index + 1, cards.length));
          card.querySelectorAll('a, [data-video-retry], [data-video-sound], [data-video-autoplay]').forEach((control) => { control.tabIndex = offset === 0 ? 0 : -1; });
          if (card.frame) card.frame.tabIndex = offset === 0 ? 0 : -1;
          if (this.visible && Math.abs(offset) <= 1 && !card.frame && card.dataset.state !== 'failed') this.load(card);
        });
        this.querySelectorAll('.squizy-videos__nav').forEach((button) => { button.hidden = cards.length < 2; });
        this.querySelectorAll('[data-video-autoplay]').forEach((button) => button.setAttribute('aria-pressed', String(this.autoAdvance)));
        if (announce) this.querySelector('[data-video-position]').textContent = this.positionText(this.index + 1, cards.length);
        this.syncPlayback();
      }

      positionText(current, total) { return this.dataset.positionLabel.replace('[current]', current).replace('[total]', total); }

      select(index, announce) {
        this.index = index;
        this.userPaused = false;
        this.render(announce);
      }

      syncPlayback() {
        const active = this.availableCards()[this.index];
        this.cards.forEach((card) => {
          if (!card.ready) return;
          const play = card === active && this.visible && !document.hidden && !this.userPaused && !window.Shopify?.designMode;
          this.send(card, card === active && !this.muted && play ? 'unMute' : 'mute');
          this.send(card, play ? 'play' : 'pause');
        });
        this.updateSound();
      }

      updateSound() {
        this.querySelectorAll('[data-video-sound]').forEach((button) => {
          button.setAttribute('aria-pressed', String(!this.muted));
          button.setAttribute('aria-label', this.muted ? this.dataset.mutedLabel : this.dataset.audibleLabel);
        });
      }

      handleClick(event) {
        if (this.suppressClick && event.target.closest('[data-video-action]')) { event.preventDefault(); return; }
        const target = event.target.closest('button');
        if (!target) return;
        if (target.hasAttribute('data-video-next')) this.select(this.index + 1, true);
        else if (target.hasAttribute('data-video-previous')) this.select(this.index - 1, true);
        else if (target.hasAttribute('data-video-autoplay')) {
          this.autoAdvance = !this.autoAdvance;
          this.querySelectorAll('[data-video-autoplay]').forEach((button) => button.setAttribute('aria-pressed', String(this.autoAdvance)));
        } else if (target.hasAttribute('data-video-sound')) {
          this.muted = !this.muted;
          this.send(this.availableCards()[this.index], this.muted ? 'mute' : 'unMute');
          this.updateSound();
        } else {
          const card = target.closest('[data-video-url]');
          if (!card) return;
          const index = this.availableCards().indexOf(card);
          if (index !== this.index) { this.select(index, true); return; }
          if (target.hasAttribute('data-video-retry')) {
            clearTimeout(card.loadTimer);
            card.frame?.remove();
            card.frame = null;
            this.userPaused = false;
            this.load(card);
          } else if (target.hasAttribute('data-video-action')) {
            if (!card.frame || card.dataset.state === 'failed') {
              card.querySelector('[data-video-retry]').click();
              return;
            }
            this.userPaused = card.classList.contains('is-playing');
            this.send(card, this.userPaused ? 'pause' : 'play');
          }
        }
      }

      handleMessage(event) {
        if (event.origin !== 'https://www.tiktok.com') return;
        let data = event.data;
        if (typeof data === 'string') { try { data = JSON.parse(data); } catch { return; } }
        if (!data || data['x-tiktok-player'] !== true) return;
        const card = this.cards.find((candidate) => candidate.frame?.contentWindow === event.source);
        if (!card || card.hidden) return;
        if (data.type === 'onPlayerReady') {
          clearTimeout(card.loadTimer);
          card.ready = true;
          card.dataset.ready = '';
          card.dataset.state = 'ready';
          this.send(card, 'mute');
          this.syncPlayback();
        } else if (data.type === 'onStateChange') {
          const playing = Number(data.value) === 1;
          if (playing && (card !== this.availableCards()[this.index] || !this.visible || document.hidden)) {
            this.send(card, 'mute');
            this.send(card, 'pause');
            return;
          }
          card.classList.toggle('is-playing', playing);
          card.querySelector('[data-video-action]').setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
          if (Number(data.value) === 0 && card === this.availableCards()[this.index] && this.autoAdvance && this.visible && !document.hidden) this.select(this.index + 1, false);
        } else if (data.type === 'onPlayerError') {
          const code = Number(data.value?.errorCode ?? data.errorCode);
          if (code === 3002) { card.dataset.state = 'blocked'; card.classList.remove('is-playing'); }
          else this.fail(card, code === 1001);
        }
      }
    }
    customElements.define('squizy-video-carousel', SquizyVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
